<!-- 缺陷平均响应时间 -->
<template>
  <div>
    <a-card v-show="!loading" size="small" :bordered="false">
      <template slot="title">
        <span style="margin-right: 4px">提审通过率</span>
        <a-popover title="报表说明" placement="topLeft">
          <template slot="content">
            <p>时间: 创建时间</p>
            <p>描述: 所选时间段内各团队流程提审通过率，提审通过率 = 通过提审单数 / 通过提审单数 + 驳回提审单数</p>
            <p>排序: 提审通过率正序（默认）</p>
          </template>
          <a-icon type="question-circle" />
        </a-popover>
      </template>
      <div :id="id" :style="{ height: height, width: width }" />
    </a-card>
    <a-card v-show="loading" :loading="loading"><span /> </a-card>
  </div>
</template>
<script>
import { releasePassedRate } from '@/api/data/workflow';
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      id: 'release-passed-rate',
      loading: true,
      showModal: 'team',
      myChart: null,
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: params => {
            let formatter = '<b>' + params[0].name + '</b><br/>';
            formatter += params[0].marker + params[0].seriesName + '<span style="float: right; margin-left:16px"><b style="color: #5A6FC0;">' + params[0].value + '</b> %</span><br/>';
            formatter += params[1].marker + params[1].seriesName + '<span style="float: right"><b style="color: #9ECA7F;">' + params[1].value + '</b> 次</span><br/>';
            formatter += params[2].marker + params[2].seriesName + '<span style="float: right"><b style="color: #F2CA6B;">' + params[2].value + '</b> 次</span><br/>';
            formatter += params[3].marker + params[3].seriesName + '<span style="float: right"><b style="color: #DE6E6A;">' + params[3].value + '</b> 次</span><br/>';
            return formatter;
          }
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
        },
        legend: {},
        yAxis: [
          {
            type: 'value',
            scale: true,
            name: '提审单数量'
          },
          {
            type: 'value',
            name: '提审通过率',
            axisLabel: {
              formatter: '{value}%'
            }
          }
        ],
        series: []
      },
      data: []
    };
  },
  watch: {
    filterForm() {
      this.getReleasePassedRate();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar'); // 柱状图
    require('echarts/lib/chart/line'); // 折线图
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    require('echarts/lib/component/grid');
    require('echarts/lib/component/dataZoom');
    require('echarts/lib/component/markLine');
    this.myChart = echarts.init(document.getElementById(this.id));
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用 */
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option, true);
      setTimeout(() => {
        this.myChart.resize();
      }, 0);
    },
    getReleasePassedRate() {
      this.loading = true;
      releasePassedRate({ ...this.filterForm, sorter: 'passed_rate', show_modal: this.showModal })
        .then(res => {
          this.data = res.data.items;
          const x_axis = [];
          const passed_rates = [];
          const passeds = [];
          const rejecteds = [];
          const returneds = [];
          this.data.forEach(el => {
            x_axis.push(this.showModal === 'team' ? el.team_name : el.nickname);
            passed_rates.push(el.passed_rate);
            passeds.push(el.passed);
            rejecteds.push(el.rejected);
            returneds.push(el.returned);
          });

          this.option.xAxis.data = x_axis;
          this.option.series = [
            {
              type: 'line',
              label: {
                show: true,
                position: 'top',
                formatter: '{c}%'
              },
              yAxisIndex: 1,
              name: '提审通过率',
              data: passed_rates
            },
            {
              type: 'bar',
              label: {
                show: true
              },
              emphasis: {
                focus: 'series'
              },
              stack: 'release',
              name: '通过',
              data: passeds
            },
            {
              type: 'bar',
              label: {
                show: true,
                position: 'top'
              },
              emphasis: {
                focus: 'series'
              },
              name: '退回',
              data: returneds
            },
            {
              type: 'bar',
              label: {
                show: true,
                position: 'top'
              },
              emphasis: {
                focus: 'series'
              },
              name: '驳回',
              data: rejecteds
            }
          ];
          this.drawChart();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}
/deep/.ant-card-small > .ant-card-body {
  padding: 0;
}
</style>
